import request from '@/utils/request'

export function downloadFile(id) {
  return request({
    url: '/article/download',
    method: 'get',
    params:{id:id},
    responseType: 'blob'
  })
}





// WEBPACK FOOTER //
// ./src/api/article.js